export default {
    load(src = 'https://api-maps.yandex.ru/2.1/?apikey=f639b4e8-7052-4a65-b8ef-829045b1aed5&lang=ru_RU') {
        if (!this.promise) {
            this.promise = new Promise((resolve, reject) => {
                const scriptElement = document.createElement('script');
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                scriptElement.type = 'text/javascript';
                scriptElement.src = src;
                document.body.appendChild(scriptElement);
            }).then(() => {
                return  new Promise(resolve => {
                    ymaps.ready(() => {
                        resolve(ymaps);
                    });
                });

            });
        }
        return this.promise;
    }
};